import { render } from "./ContactList.vue?vue&type=template&id=00a8c2b6"
import script from "./ContactList.vue?vue&type=script&lang=ts"
export * from "./ContactList.vue?vue&type=script&lang=ts"
script.render = render

export default script